import { apiURL, axiosInstance } from "constants/config";
import {
  loadCustomerQueryRequested,
  loadCustomerQuerySuccess,
  loadCustomerQueryFail,
  loadCustomerActivityLogsRequested,
  loadCustomerActivityLogsSuccess,
  loadCustomerActivityLogsFail,
  loadCustomerActivityLogsByWeeklyRequested,
  loadCustomerActivityLogsByWeeklySuccess,
  loadCustomerActivityLogsByWeeklyFail,
  loadReceiptsRequested,
  loadReceiptsSuccess,
  loadReceiptsFail,
  sendMailRequested,
  sendMailSuccess,
  sendMailFail,
  loadPaperQueryRequested,
  loadPaperQuerySuccess,
  loadPaperQueryFail,
} from './reportSlice';
import { put, call, takeEvery, all } from "redux-saga/effects";
import toast from "react-hot-toast";

export function* loadCustomerQueryEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/reports/customers/query?CustomerReference=${
        action?.payload?.reference ?? ""
      }&RoundId=${action?.payload?.round ?? ""}&Street=${
        action.payload?.street ?? ""
      }`
    );
    if (data?.succeeded) {
      yield put(loadCustomerQuerySuccess(data));
    }
  } catch (error: any) {
    yield put(loadCustomerQueryFail(error.meessage));
  }
}

export function* loadCustomerActivityLogsEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${apiURL}/reports/customers/activity-logs`,
      action.payload
    );
    if (data?.succeeded) {
      yield put(loadCustomerActivityLogsSuccess(data));
    }
  } catch (error: any) {
    yield put(loadCustomerActivityLogsFail(error.meessage));
  }
}

export function* loadCustomerActivityLogsByWeeklyEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${apiURL}/reports/customers/activity-logs-by-weekly`,
      action.payload
    );
    if (data?.succeeded) {
      yield put(loadCustomerActivityLogsByWeeklySuccess(data));
    }
  } catch (error: any) {
    yield put(loadCustomerActivityLogsByWeeklyFail(error.meessage));
  }
}

export function* loadReceiptsEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const idsQuery = action.payload?.map((id: any) => `ids=${id}`).join("&");
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/reports/customers/bills?${idsQuery}`
    );

    if (data?.succeeded) {
      yield put(loadReceiptsSuccess(data));
    }
  } catch (error: any) {
    yield put(loadReceiptsFail(error.message));
  }
}

export function* sendMailEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    // const idsQuery = action.payload?.ids?.map((id: any) => `ids=${id}`).join('&');
    const { data } = yield call(
      axiosInstance.post,
      `${apiURL}/reports/email/activitylog?startDate=${action.payload?.startDate}&endDate=${action.payload?.endDate}`,
      action.payload?.ids
    );
    if (data?.succeeded) {
      yield put(sendMailSuccess(data));
      toast.success(
        "Emails have been successfully sent to all selected customers"
      );
    }
  } catch (error: any) {
    yield put(sendMailFail(error.message));
  }
}

export function* loadPaperQueryEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/reports/papers/summary?startDate=${
        action?.payload?.startDate
      }&endDate=${action?.payload?.endDate}&branchId=${
        action?.payload?.branch ?? ""
      }`
    );
    if (data?.succeeded) {
      yield put(loadPaperQuerySuccess(data));
    }
  } catch (error: any) {
    yield put(loadPaperQueryFail(error.meessage));
  }
}

export function* reportsSaga(): Generator<any, void, any> {
  yield all([
    takeEvery(loadCustomerQueryRequested, loadCustomerQueryEffect),
    takeEvery(
      loadCustomerActivityLogsRequested,
      loadCustomerActivityLogsEffect
    ),
    takeEvery(
      loadCustomerActivityLogsByWeeklyRequested,
      loadCustomerActivityLogsByWeeklyEffect
    ),
    takeEvery(loadReceiptsRequested, loadReceiptsEffect),
    takeEvery(sendMailRequested, sendMailEffect),
    takeEvery(loadPaperQueryRequested, loadPaperQueryEffect),
  ]);
}
